import { KeyboardEvent } from 'react';

export function isEnterKeyPressed(event: KeyboardEvent) {
  return event.key === 'Enter';
}
